module.exports = __webpack_public_path__ + "img/Right_arrow_button.12ac4d0e.svg";